/** Same paths as `ew-ui/src/actions/Actions.js` (browser uses same-origin + dev proxy). */
export const GROUP_INFO_ACTION = "/usermanager/group/group_info/";
export const DEACTIVATE_USER_ACTION = "/usermanager/group/deactivate_user/";
export const BULK_UPDATE_ACTION = "/usermanager/user/bulk_name_update/";
export const FETCH_USER_ACTION = "/usermanager/user/";
export const FETCH_USER_PREFERENCES = "/usermanager/user_preferences/";
export const UPDATE_USERNAME_ACTION = "/usermanager/user/update_name/";
export const UPDATE_USER_PREFERENCES = "/usermanager/user_preferences/update/";
/**
 * Trailing slash required: upstream Django (APPEND_SLASH) only serves JSON at the
 * canonical slashed path; the slash-less form falls through to the SPA index.html
 * catch-all. Dev-proxy already rewrites any absolute upstream redirect to localhost
 * (`rewriteUpstreamRedirectToDevServer`), so 308 Location does not bypass it.
 */
export const SEARCH_HISTORY_ACTION = "/usermanager/search_history/";

/** Same rationale as `SEARCH_HISTORY_ACTION`. */
export const SCRAPING_ACTION = "/usermanager/scraping_account/";
export const SCRAPING_ACTION_NEW_TELEGRAM = `${SCRAPING_ACTION}new_telegram/`;
export const SCRAPING_ACTION_NEW_CODE = `${SCRAPING_ACTION}new_code/`;
export const SCRAPING_ACTION_DISCORD_USER_PASS_CAPTCHA =
  `${SCRAPING_ACTION}discord_user_pass_captcha/`;
export const SCRAPING_ACTION_DISCORD_USER_PASS_LOGIN =
  `${SCRAPING_ACTION}discord_user_pass_login/`;
export const SCRAPING_ACTION_QR_TOKEN = `${SCRAPING_ACTION}get_qr_token/`;
export const SCRAPING_ACTION_START_DISCORD_LOGIN =
  `${SCRAPING_ACTION}start_discord_login/`;
export const SCRAPING_ACTION_CHECK_DISCORD_LOGIN =
  `${SCRAPING_ACTION}check_discord_login/`;
export const SCRAPING_ACTION_DELETE_TELEGRAM = `${SCRAPING_ACTION}delete_telegram/`;
export const SCRAPING_ACTION_DELETE_DISCORD = `${SCRAPING_ACTION}delete_discord/`;
export const SCRAPING_ACTION_START_BOT = `${SCRAPING_ACTION}start_bot/`;

/** Elasticsearch query endpoints (same as `ew-ui/src/actions/Actions.js`). */
export const FULL_SEARCH_ACTION = "/full_search";
export const FULL_SEARCH_COUNT_ACTION = "/full_search_count";
export const CONTEXT_SEARCH_ACTION = "/context_search";
export const RAW_DATA_ACTION = "/raw_data";

/** Create exclusion row (POST body includes `user_id` + `exclusion`). */
export const ADD_EXCLUSION_ACTION = "/exclusions";
